import React from "react";
import { SvgProps } from "./Form";

export const ThinArrowRight = (props: SvgProps) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="8"
    viewBox="0 0 20 8"
    fill="none"
  >
    <path
      d="M19.8536 4.03568C20.0488 3.84042 20.0488 3.52384 19.8536 3.32858L16.6716 0.146595C16.4763 -0.0486672 16.1597 -0.0486672 15.9645 0.146595C15.7692 0.341857 15.7692 0.65844 15.9645 0.853702L18.7929 3.68213L15.9645 6.51056C15.7692 6.70582 15.7692 7.0224 15.9645 7.21766C16.1597 7.41293 16.4763 7.41293 16.6716 7.21766L19.8536 4.03568ZM0.5 3.18213C0.223858 3.18213 0 3.40599 0 3.68213C0 3.95827 0.223858 4.18213 0.5 4.18213V3.68213V3.18213ZM19.5 3.68213V3.18213H0.5V3.68213V4.18213H19.5V3.68213Z"
      fill="currentColor"
    />
  </svg>
);
